<template>
  <div id="app">
    <div id="wrapper">
      <div id="wrapper-inner">
        <head-comp />
        <!-- <nav-comp v-if="!navVisible" /> -->
        <router-view />
      </div>
    </div>
    <!-- <footer-comp id="footer" /> -->
    <AnchorComp
      :flag_hidden="flag_visible"
      :footerShow="footerShow"
      :top="top"
    />
    <!-- <CompareListComp ref="compare" /> -->
  </div>
</template>

<script>
import "../src/assets/css/base/common.less";
import HeadComp from "./components/header";
import FooterComp from "./components/footer/Footer";
import AnchorComp from "./components/anchor/Anchor";
import { getQueryString, unionFlag } from "@/utils";
import { mapMutations } from "vuex";
import { setThemeColor, readThemeColor, writeThemeColor } from '@/utils/themeColor'
// 页面刷新，滚动条回到最顶部
// window.addEventListener("beforeunload", () => {
//   window.scrollTo(0, 0);
// });

export default {
  data() {
    return {
      flag_visible: null,
      blackList: [
        "orderCompletion",
        "orderlist",
        "orderDetail",
        "appointSuccess",
        "localAppointmentSucc",
        "appointFail",
        "searchResult",
      ],
      navVisible: true,
      footerShow: false, //判断footer是否露出来
      top: 0,
    };
  },
  components: {
    HeadComp,
    FooterComp,
    AnchorComp,
  },
  created() {
    const union = unionFlag();
    this.getCommonThemeMethod()
    if (union && union !== "stage") {
      this.apis.home.getBili().then((data) => {
        if (data.respCode === "00000000") {
          this.setUnionInfo(data);
        } else {
          this.setUnionInfo({});
        }
      });
    }
    if (sessionStorage.getItem("showStore")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("showStore"))
        )
      );
    }
    window.addEventListener("scroll", this.handleScroll);
    // 获取工会信息
    // if (!this.publicMethod.unionFlag() != true) {
    //   let unionData = {
    //     union: this.publicMethod.unionFlag(),
    //     unionFlag: 1
    //   };
    //   this.apis.showOrder.getUnionSource(unionData).then(res => {
    //     console.log("union——data", res);
    //   });
    // }
  },
  watch: {
    // 监听当前页面是否是套餐对比
    $route() {},
  },
  mounted() {
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("showStore", JSON.stringify(this.$store.state));
    });
    document.title = "演出";
    if (getQueryString("mc")) {
      window.sessionStorage.setItem("currentChannel", getQueryString("mc"));
    };
  },
  methods: {
    ...mapMutations(["setUnionInfo"]),
    async getCommonThemeMethod() {
      let color = readThemeColor()
      if(color) {
        setThemeColor(color)
      }
      try {
        if(color) {
          this.apis.home.getCommonTheme().then((res) => {
            this.setColor(res, false)
          })
        } else {
          const res = await this.apis.home.getCommonTheme()
          this.setColor(res, true)
        }
      } catch (error) {
        setThemeColor('#3FA6FF')
      }
    },
    setColor(data, isAsync) {
      if(data && data.code == '0') {  
        const currentColor = data.Data.globalThemeColor 
        if(currentColor) {
          if(isAsync) {
            setThemeColor(currentColor)
          }
          if(data.Data) {
            writeThemeColor(data.Data)
          }
        }
      } else {
        setThemeColor('#3FA6FF')
      }
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop != 0) {
        this.footerShow = true;
      } else {
        this.footerShow = false;
        this.totophover = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  height: 100%;
}

#wrapper {
  min-height: 100%;
  &-inner {
    padding-bottom: 410px;
  }
}
</style>
